import { render, staticRenderFns } from "./StartTest.vue?vue&type=template&id=e0d2daae&scoped=true&"
import script from "./StartTest.vue?vue&type=script&lang=js&"
export * from "./StartTest.vue?vue&type=script&lang=js&"
import style0 from "./StartTest.vue?vue&type=style&index=0&id=e0d2daae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d2daae",
  null
  
)

export default component.exports